import React from "react";

const ConsumptionReport = ({ resPacket }) => {
  return (
    <div>
      {resPacket && resPacket.length > 0 ? (
        <div className="customTable"  id="scroll">
          <table className="customTable w-100">
            <thead className="fixed-thead">
              <tr>
                <th>SNO.</th>
                <th className="pl-4">ITEM CODE</th>
                <th className="pl-4">ITEM NAME</th>
                <th className="pl-4">MONTHLY CONS.</th>
                <th className="pl-4">UOM</th>
                <th className="pl-4">CURRENT STOCK</th>
                <th className="pl-4">UOM</th>
                <th className="pl-4">STOCK DAYS</th>
              </tr>
            </thead>
            <tbody className="body-scroll-custom">
              {resPacket.map((row, i) => (
                <tr key={i}>
                  <td>{i + 1}</td>
                  <td>{row.itemCode}</td>
                  <td>{row.itemTitle}</td>
                  <td>{row.avgPerMonthQty}</td>
                  <td>{row.unitOfQty}</td>
                  <td>{row.inStockQty}</td>
                  <td>{row.unitOfInStockQty}</td>
                  <td>{row.dayLeft}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="my-3 text-black text-center">No Records Found</div>
      )}
    </div>
  );
};

export default ConsumptionReport;
